import React from 'react';
import { hot } from 'react-hot-loader';
import classnames from 'classnames';

import Map from './map/components/map/Map';
import Wizard from './app/components/wizard/Wizard';
import { useMobile } from './common/components/responsive/Responsive';

import './App.scss';

const App = () => {
  const isMobile = useMobile();

  return (
    <div className={classnames('app', isMobile && 'mobile')}>
      <Map />
      <Wizard className="app__wizard" />
    </div>
  );
};
export default hot(module)(App);
